<template>
  <form @submit.prevent="logout">
    <div class="form_box">
      <p class="submit"><input type="submit" value="ログアウト"></p>
    </div>
  </form>
</template>

<script>
export default {
  name: 'Logout',
  data () {
    return {
    }
  },
  methods: {
    logout () {
      this.$router.replace('/logout')
    }
  }
}
</script>

<style scoped>
  @import '../assets/css/user.css'
</style>



// WEBPACK FOOTER //
// src/components/Logout.vue